// Отзыв (используется в оформлении сказок).
export const SKAZKI_STAR_REVIEW = 'Собрали сказку за полминуты, пока сын чистил зубы. Он слушал без движения и попросил ещё. Утром первое, что сказал: «Мам, а можно ту сказку, где я нашёл лунную дорогу?» Теперь это наш вечерний ритуал.';

// Конфиг главной страницы — приложение «Сказки».
const HOME_CONFIG = {
    title: 'Магазин чудес — персональные сказки для детей с озвучкой',
    description: 'Создайте персональную аудиосказку для ребёнка за 30 секунд. Имя, возраст, любимые увлечения — и готовая сказка с озвучкой и текстом.',
};

export function getPageConfig() {
    return HOME_CONFIG;
}
